import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ServiceBase } from './service-base';
import { ResultVO } from './vo/CommonVO';
import { environment } from 'src/environments/environment';
import { MyService } from './MyService';


@Injectable({ providedIn: 'root' })
export class GoService extends MyService {


  constructor(public http: HttpClient) { 
    super(http);    
   // this.apiu =  this.apiEndpoint+"/"+ this.apiPrefix+"go/" ;
    this.apiPrefix =  environment.urls.prefix+"Go/"
  }

  
}